/* eslint-disable no-param-reassign */

// Capitalize First Letter Of String
export default (str) => {
	const exceptions = ["lat", "years", "let", "jahre", "років", "лет"];
	const exceptionsSex = [
		"kobieta",
		"woman",
		"žena",
		"frau",
		"жінка",
		"женщина",
		"mężczyzna",
		"man",
		"muž",
		"mann",
		"чоловік",
		"мужчина",
		"para",
		"couple",
		"pár",
		"paar",
		"пара",
		"пара",
		"trans",
		"trans",
		"transsexuálů",
		"transsexuellen",
		"транссексуали",
		"транссексуалы",
	];
	str = String(str).toString();
	str = str.replace(/\p{L}[\p{L}\p{M}\p{N}]*/gu, (txt) => {
		if (exceptions.includes(txt.toLowerCase())) return txt;
		if (exceptionsSex.includes(txt.toLowerCase())) return txt.toLowerCase();

		return txt.charAt(0).toUpperCase() + txt.substr(1);
	});
	return str;
};
